import { useState, useCallback } from 'react';
import { AGENTS } from '../../utils/agents';
import { useActivityStore } from '../../stores/activityStore';
import { usePolling } from '../../hooks/usePolling';
import OfficeControls from './OfficeControls';
import OfficeMap from './OfficeMap';
import OfficeLiveActivity from './OfficeLiveActivity';
import { useConversations } from './useConversations';

export default function OfficePage() {
  const { events, loading, fetchEvents } = useActivityStore();
  const [pulsing, setPulsing] = useState(false);

  // Poll activity feed every 30 seconds
  usePolling(fetchEvents, 30_000);

  const {
    conversations,
    getAgentPosition,
    triggerExtraConversation,
  } = useConversations(AGENTS);

  const activeConversations = conversations.filter(
    (c) => c.phase !== 'done'
  ).length;

  const handleTeamMeeting = useCallback(() => {
    setPulsing(true);
    setTimeout(() => setPulsing(false), 2000);
  }, []);

  return (
    <div className="flex flex-col h-full gap-4 p-4">
      {/* Controls bar */}
      <OfficeControls
        agentCount={AGENTS.length}
        activeConversations={activeConversations}
        onWaterCooler={triggerExtraConversation}
        onTeamMeeting={handleTeamMeeting}
      />

      {/* Main content: Map + Sidebar */}
      <div className="flex-1 flex flex-col lg:flex-row gap-4 min-h-0">
        {/* Office map */}
        <div className="flex-1 min-w-0">
          <OfficeMap
            agents={AGENTS}
            conversations={conversations}
            getAgentPosition={getAgentPosition}
            activityEvents={events}
            pulsing={pulsing}
          />
        </div>

        {/* Live Activity sidebar — hidden on small screens */}
        <div className="hidden md:block w-full lg:w-56 lg:shrink-0 bg-bg-secondary border border-border-subtle rounded-xl overflow-hidden">
          <OfficeLiveActivity events={events} loading={loading} />
        </div>
      </div>
    </div>
  );
}
